'use client'

import { ProductReviewListItemProps } from "@/types/review"
import { useTranslate } from "@tolgee/react"
import { useEffect, useState } from "react"
import { ProductReviewItem } from "./ProductReviewItem"
import { Pagination } from "@/components/cells"
import { loadProductReviews } from "@/lib/data/product-reviews"

export const ProductReviewList = ({
  // listLoader,
  product_id,
  locale,
  handleReviewsSummary,
}: {
  product_id: string,
  locale: string
  handleReviewsSummary?: (summary: any) => void
}) => {
  const { t } = useTranslate()

  const pageSize = 10;
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0)
  const [reviews, setReviews] = useState<ProductReviewListItemProps[]>([])
  const [isLoading, setIsLoading] = useState(false)

  const setPageHandler = async (page: number) => {
    setPage(page)
    setIsLoading(true)
    const result = await loadProductReviews(product_id, pageSize, page)
    setReviews(result.list)
    setTotal(result.count)
    setIsLoading(false)
    if (page <= 1 && handleReviewsSummary) {
      handleReviewsSummary((result as any).summary!)
    }
  }

  useEffect(() => {
    setPageHandler(page)
  }, [])


  if (isLoading) {
    return (
      <div className="px-6 py-4">
        <div className="space-y-6">
          <div className="animate-pulse">
            <div className="h-6 w-3/6 bg-gray-200 rounded mb-3"></div>
            <div className="h-6 w-full  bg-gray-200 rounded mb-3"></div>
            <div className="h-8 w-4/6 bg-gray-200 rounded mb-3"></div>
            <div className="h-5 w-2/6 bg-gray-200 rounded mb-3"></div>
          </div>
          <div className="animate-pulse">
            <div className="h-6 w-3/6 bg-gray-200 rounded mb-3"></div>
            <div className="h-6 w-full  bg-gray-200 rounded mb-3"></div>
            <div className="h-8 w-4/6 bg-gray-200 rounded mb-3"></div>
            <div className="h-5 w-2/6 bg-gray-200 rounded mb-3"></div>
          </div>
          <div className="animate-pulse">
            <div className="h-6 w-3/6 bg-gray-200 rounded mb-3"></div>
            <div className="h-6 w-full  bg-gray-200 rounded mb-3"></div>
            <div className="h-8 w-4/6 bg-gray-200 rounded mb-3"></div>
            <div className="h-5 w-2/6 bg-gray-200 rounded mb-3"></div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <>
      {reviews.length > 0 ? (
        <div className="px-6 py-4">
          {reviews.map(review => (
            <ProductReviewItem key={review.id} review={review} />
          ))}
          <div className="mt-6 flex justify-center">
            <Pagination
              pages={Math.ceil(total / pageSize)}
              setPage={setPageHandler}
              currentPage={page}
            />
          </div>
        </div>
      ) : (
        <div className="flex items-center justify-center min-h-[160px] py-16 px-6 text-[14px] text-[#717182] tracking-[-0.15px]">
          {t('product_review.reviews_empty')}
        </div>
      )}
    </>
  )
}
